module.exports = __webpack_public_path__ + "static/DoleJar_zpsoxhsjy0a-c959c18cbd7e2ca03f8de0f4cbcb9c78.jpg";